module.exports = __webpack_public_path__ + "static/media/btn-social-twitter.7b1db1a9.png";